import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IRetorno } from '@model/Retorno';
import { IRetornoFilter } from '@services/RetornoService';
import React from 'react';
import { RetornoDetalheModal } from './RetornoDetalheModal';

export type RetornoTableProps = {
    isLoading: boolean
    data: IData<IRetorno, IRetornoFilter>
    tableContainerProps?: TableContainerProps
    menu: IMenu
}

export function RetornoTable ({ isLoading, data, tableContainerProps, menu }: RetornoTableProps) {
    const formatter = useFormatter();
    const detalheModal = useModalWindow();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="retornoId">ID</TableSortCell>
                        <TableSortCell fieldName="carteiraCobrancaContaBancariaBancoNome">Banco</TableSortCell>
                        <TableSortCell fieldName="carteiraCobrancaCodigoCedente">Convênio</TableSortCell>
                        <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="dataHora">Importado em</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((retorno, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(retorno, detalheModal.open)}>{retorno.retornoId}</Anchor></TableKeyCell>
                                    <TableCell>{retorno.carteiraCobrancaContaBancariaBancoNome}</TableCell>
                                    <TableCell>{retorno.carteiraCobrancaCodigoCedente}</TableCell>
                                    <TableCell>{retorno.empresaNome}</TableCell>
                                    <TableCell>{formatter.toDate(retorno.dataHora)}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(retorno, menu.open)} />
                                </TableRow>
                            )
                        })
                    }
                    <Pagination pagination={data.pagination} />
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <RetornoDetalheModal 
                        retornoId={data.focusedRow.retornoId}
                        modal={detalheModal}
                    />
                )
            }
        </React.Fragment>
    )
}